<template>
	<div class="SZtemplate">
		<div class="title" :style="'text-align:center'">
			<H1> 模板列表 </H1>
		</div>  
		<div class="SZlist cotent">
			<el-collapse v-model="activeName" accordion class="item headitem ul">
				<el-collapse-item v-for="(item, index) in newList" :key="index" :title="item.title" :name="index">
					<ul>
						<li @click="toEdit(item.Fn, false, '')">新增模板</li>
						<li v-for="(mitem, mindex) in modelList" :key="mindex" style="padding: 1px 10px">
							<span style="display: inline-block; max-width: 1000px">
								{{ mitem.TemplateTitle }}：
							</span>

							<span class="span" :style="mitem.Def ? 'color:rgb(137, 188, 238);font-weight:bold' : ''" @click="setdef(mitem)">
								{{ mitem.Def ? "默认模板" : "设为默认" }}
							</span>

							<span class="span" @click="toPreview(mitem)">
								预览模板
							</span>
							<span class="span" :style="'color:red'" @click="to_del(mitem)">
								删除模板
							</span>
						</li>
					</ul>
				</el-collapse-item>
			</el-collapse>
		</div>

		<el-drawer size="70%" :visible.sync="drawer" :direction="direction" :modal-append-to-body="false"
			id="yulan_view">
			<template slot="title">
				<h3>
					{{ view_title }}
				</h3>
				<h4>
					{{ set_view }}
				</h4>
			</template>
		</el-drawer>

		<!-- 删除模板确认弹窗 -->
		<van-dialog v-model="showDelTemplate" title="是否删除此模板" show-cancel-button :beforeClose="changeDelbtn">
		</van-dialog>
	</div>
</template>

<script>
	import axiosp from "axios";
	import { Dialog, Field } from "vant";
	import { mapState } from "vuex";
	const baseUrl = "http://8.131.84.184:3000/api/";
	export default {
		components: {
			[Dialog.name]: Dialog,
			[Field.name]: Field,
		},
		computed:{
			...mapState({
				TempState: 'TempState'
			})
		},
		data() {
			return {
				view_title: "预览模板",
				set_view: "",
				drawer: false,
				direction: "rtl",
				newList: [{
						title: "销售单模板",
						Fn: "SH",
					},
					{
						title: "销售订单模板",
						Fn: "XS",
					},
					{
						title: "进货单模板",
						Fn: "JH",
					},
					{
						title: "采购订单模板",
						Fn: "CG",
					},
					{
						title: "付款单模板",
						Fn: "FK",
					},
					{
						title: "收款单模板",
						Fn: "SK",
					},
					{
						title: "调拨单模板",
						Fn: "DB",
					},
				],
				stype: "SH",
				activeName: 0,
				modelList: [],
				show: false,
				msg: "",
				curritemid: "",

				showDelTemplate: false,
				delTemplateType: "",
				delTemplateID: "",
			};
		},
		watch: {
			activeName(newVaule) {
				this.activeName = newVaule;
				this.get_model_list(newVaule);
			},
			stype(newVaule) {
				this.stype = newVaule;
			},
			TempState(val) {
				console.log(val)
				this.get_model_list();
			},
		},
		mounted() {
			this.get_model_list();
		},
		methods: {
			// 删除模板
			delTemplate(id) {
				this.showDelTemplate = true;
				this.delTemplateType = id.slice(4, 6); // 要删除的模板类型
				this.delTemplateID = id;
			},

			// 预览 弹窗按钮
			changeDelbtn(btn, done) {
				if (btn === "confirm") {
					axiosp.get(baseUrl + this.delTemplateType + "/del:" + this.delTemplateID).then((res) => {
						if (res.code == 0) {
							let data = res.data;
							console.log(data);
							// this.get_model_list()
						} else {
							this.$Message.error(res.msg);
						}
					});
				}
				this.showDelTemplate = false;
				done();
			},

			// 获取模板列表
			get_model_list(idx = 0) {
				let _that = this;
				_that.modelList = [];
				let user_info = this.$fun.GetUserConstant();
				console.log("idx", idx, "--------", _that.newList[idx || 0].Fn);
				this.$Api.temp_get_list({
					LB: _that.newList[idx || 0].Fn || idx,
					...user_info
				}).then((res) => {
					if (res.status == "SUCCESS") {
						console.log("左侧选项---------", res);
						// 筛选模板名字不为  APP 
						let newData = res.data.filter(item => item.TemplateTitle != "APP")
						_that.modelList = newData;
					}
				})
				return;
			},

			// 设置为默认模板
			setdef(item) {
				let user_info = this.$fun.GetUserConstant();
				this.$Api.temp_setdef({
					ID: item.ID,
					...user_info
				}).then((res) => {
					if (res.status == "SUCCESS") {
						this.get_model_list(this.activeName);
					} else {
						this.$Message.error(res.msg);
					}
				});
			},

			// 编辑 添加
			toEdit(stype, edit, id) {
				let pname="addtemplate";
				if(stype=="FK" || stype=="SK")
				{
					pname="addtemp_K";
				}
				if(stype=="DB")
				{
					pname="addtemp_DB"
				}
				let pathname = {
					//name: stype == "FK" || stype == "SK" ? "addtemp_K" : "addtemplate",
					name:pname,
					query: { stype, edit, id },
				};
				this.$router.push(pathname);
			},

			// 预览模板
			toPreview(val) {
				this.drawer = true;
				let view_box = document.getElementsByClassName("el-drawer__body");
				let a = JSON.parse(val.TemplateValue);
				console.log(JSON.stringify(a.set_val))
				let { P_bottom, P_width, P_height, P_left, P_right, P_top } = a.set_val;
				let set_title = `宽：${P_width}cm  高：${P_height}cm  上边距：${P_top}cm  下边距：${P_bottom}cm  左边距：${P_left}cm  右边距：${P_right}cm`;
				this.view_title = val.TemplateTitle;
				this.set_view = set_title;
				setTimeout(() => {
					view_box[0].innerHTML = a.temphtml;
				}, 51);
			},

			// 预览 弹窗按钮
			chargeBtn(action, done) {
				//确认or取消
				if (action === "cancel") {
					//取消按钮
					this.show = false;
					this.curritemid = "";
					this.msg = "";
					done();
				} else if (action === "confirm") {
					//确定按钮
					//向后端传值并关闭dialog弹出框
					this.show = false;
					let pathname = {
						name: "testtemplate",
						// path: '/SetSystem/testtemplate/:stype/:msg',
						// redirect: { name: '/erpprint/testtemplate/:stype/:msg' },
						// 类型 JH XS   单号           模板号
						query: {
							stype: this.stype,
							msg: this.msg,
							id: this.curritemid,
						},
					};
					this.$router.push(pathname);
				}
				this.msg = "";
				this.curritemid = "";
				done();
			},

			// 删除模板
			to_del(item) {
				let user_info = this.$fun.GetUserConstant();
				this.$Api.temp_del({
					ID: item.ID,
					...user_info
				}).then((res) => {
					console.log(res, "--------res");
					if (res.status == "SUCCESS") {
						this.get_model_list(this.activeName);
					} else {
						this.$Message.error(res.msg);
					}
				}).then(() => {});
			},
		},
	};
</script>

<style scoped>
	.SZtemplate {
		margin-top: 0px;
		width: 100%;
		padding-left: 50px;
	}

	.title {
		width: 100%;
	}

	.title>p {
		padding-top: 30px;
		font-size: 16px;
		font-family: "Microsoft YaHei";
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		overflow: hidden;
	}

	.title>p>span {
		width: 38px;
		height: 7px;
		background: rgb(34, 116, 200);
		display: block;
	}

	.SZlist {
		width: 100%;
		background-color: white;
		margin-top: 5px;
	}

	.cotent>>>.el-collapse {
		margin: 0px 2px;
	}

	.ul>>>.el-collapse-item__content {
		display: flex;
		padding: 0px 60px;
	}

	.el-collapse-item__content>ul {
		width: 100%;
	}

	.el-collapse-item__content>ul li {
		border-bottom: 1px solid #ebeef5;
		line-height: 40px;
		height: 40px;
		font-size: 14px;
		color: slategrey;
	}

	.el-collapse-item__content>ul li:before {
		content: "";
		display: inline-block;
		width: 10px;
		height: 10px;
		background-color: rgba(34, 116, 200, 1);
		margin-right: 20px;
		border-radius: 50%;
	}

	.el-collapse-item__content>ul li:first-child {
		font-size: 14px;
		color: darkcyan;
		text-decoration: underline;
		cursor: pointer;
	}

	.el-collapse-item__content>ul li:first-child::before {
		border-radius: 1px;
	}

	.el-collapse-item__content>ul li span {
		line-height: 28px;
		height: 28px;
	}

	.el-collapse-item__content>ul li .span {
		color: darkcyan;
		text-decoration: underline;
		cursor: pointer;
		padding: 0px 20px;
		font-size: 12px;
	}

	.headitem>>>.el-collapse-item__header {
		font-family: "YouYuan";
		font-size: 16px;
		padding: 3px 50px;
		background-color: rgb(234, 239, 250);
	}

	.item>>>.el-collapse-item {
		padding: 2px 0px;
		background-color: white;
	}

	.item>>>.el-collapse-item__wrap {
		border-bottom: 0px none white;
	}
</style>
